import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useProfile } from '../profile/ProfileProvider';

/**
 * Renders children only if the signed-in user is an admin. Otherwise
 * redirects to the dashboard.
 *
 * Server-side checks always re-verify admin status — this component only
 * controls UI visibility.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { state } = useProfile();
  if (state.status !== 'ready') return null; // top-level shell handles loading
  if (!state.isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
